import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'

import { Button, Input, Span } from 'components'
import { useAuth, useModal, useToggle, useLoading } from 'hooks'
import jwt from 'jsonwebtoken'
import { Header } from 'pages/Login/components/Header/Header'
import { ModalNewUser } from 'pages/Supplier/Users/components'
import { NovoUsuarioForm } from 'pages/Supplier/Users/components/ModalNewUser/ModalNewUser'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import GenericServices from 'services/Generic/Generic'
import { UserServices } from 'services/Supplier/Users'
import { COLORS, FORMAT, SPACING } from 'utils'

import { Card, Container, HeaderCard, CardContent } from './ValidateUser.styles'

interface IParam {
  token: string
  contratoId: string
}

interface IResponseData {
  nmResponsavel: string
  cdCpfResponsavel: string
  txEmailResponsavel: string
  nuCelResponsavel: string
  cnpjValido: boolean
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

const ValidateUser: React.FC = () => {
  const { push } = useHistory()
  const { showModal } = useModal()
  const location = useLocation()
  const { token, contratoId } = useParams<IParam>()
  const [showModalUser, toggleModalUser] = useToggle()
  const { setLoading, setMsgErro } = useLoading()
  const { setUser, setAllData, setUsuarioCsn, setUsuarioFornecedor, user } =
    useAuth()

  const [email, setEmail] = useState('')
  const [resposta, setResposta] = useState('')

  const validateToken = useCallback(async () => {
    setLoading('loading')

    try {
      const { data } = await GenericServices.VerifyToken({ token })

      if (!data.sucesso) {
        throw new Error(data.mensagem)
      }

      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error.mensagem || 'Token invalido')
      setLoading('error')
      setTimeout(() => {
        push('/')
      }, 1500)
    }
  }, [token, contratoId])

  useEffect(() => {
    getEmail()
    setUser(null)
    setAllData(null)
    setUsuarioCsn(null)
    setUsuarioFornecedor(null)
    validateToken()
  }, [validateToken])

  const handleValidateAcess = async () => {
    setLoading('loading')

    try {
      const url = window.location.href
      const response = await UserServices().validateFirstAcess({
        contratoId: parseInt(contratoId),
        emailUsuario: email,
        respostaDesafio: FORMAT.unMask(resposta),
        url: url.replace(location.pathname, '')
      })
      const data = response.data as IResponseData

      if (!data.sucesso) throw new Error(data.mensagem)

      showModal({
        handleConfirm: () => toggleModalUser(),
        hideButtonCancel: true,
        message: 'Complete o formulario para enviar seus dados para validação!',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error.response.data.title || 'Erro ao cnpj Invalido!')
      setLoading('error')
    }
  }

  const getEmail = () => {
    const descripted = jwt.decode(token)
    setEmail(descripted.email)

    UserServices()
      .buscarUsuarioPorEmail(descripted.email)
      .then((response) => {
        if (response.status === 200 && response.data.idUsuario) {
          showModal({
            hideButtonCancel: true,
            message:
              'Usuário já enviado para a validação, aguarde a resposta do analista!',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          push('/')
        }
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message:
            'Houve um erro ao verificar se o usuário já foi enviado para validação.',
          type: 'error'
        })
      })
  }

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setResposta(e.target.value)
  }

  const handleAddNewUser = (requestData: NovoUsuarioForm) => {
    try {
      const cpfClient = FORMAT.unMask(requestData.cdDocto)
        .toString()
        .toLowerCase()
        .trim()

      const objEnvio = {
        cdDocto: cpfClient,
        idUsuario: 0,
        nmUsuario: requestData.nmUsuario,
        nuContato: FORMAT.unMask(requestData.nuContato),
        nuRamal: '',
        perfilUsuarioId: 9,
        txEmail: requestData.txEmail,
        usuarioFornecedor: {
          flSituacao: 'P',
          usuarioIdAdministrador: user && user.IdUsuario ? user.IdUsuario : 0
        }
      }

      UserServices()
        .create(objEnvio)
        .then(({ data }) => {
          if (data.sucesso) {
            showModal({
              handleConfirm: () => {
                push('/')
              },
              hideButtonCancel: true,
              message: 'Foi enviado para validação pelo analista!',
              txtButtonConfirm: 'Fechar',
              type: 'alert'
            })
            setLoading('idle')
          }
        })
        .catch(() => {
          showModal({
            hideButtonCancel: true,
            message: 'Ocorreu um poblema ao enviar os dados para validação.',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
    } catch (error: any) {
      setMsgErro(
        error.response?.mensagem ||
        error.response?.data?.mensagem ||
        error.mensagem ||
        error.message ||
        'Ocorreu um poblema ao enviar os dados para validação.'
      )
      setLoading('error')
    }
  }

  return (
    <>
      <Header />
      <Container>
        <Card>
          <HeaderCard>
            <Span
              text="Validação de acesso"
              color={COLORS.black}
              fontSize="20px"
              fontWeight="700"
            />
          </HeaderCard>
          <CardContent>
            <Input
              value={resposta}
              label="Código de Acesso"
              marginTop={SPACING.spacing20}
              onChange={(event) => {
                const onlyNumberAndLetters = /[a-zA-Z-0-9]/g
                if (
                  !event.target.value ||
                  onlyNumberAndLetters.test(event.target.value)
                ) {
                  handleChangeInput(event)
                }
              }}
              maxLength={8}
            />
            <Button
              text="Enviar"
              onClick={handleValidateAcess}
              marginTop={SPACING.spacing20}
            />
          </CardContent>
        </Card>
        {!!showModalUser && (
          <ModalNewUser
          
            firstUser={true}
            showModal={showModalUser}
            toggleModal={toggleModalUser}
            onSubmit={handleAddNewUser}
            emailUser={email.trim()}
          />
        )}
      </Container>
    </>
  )
}

export default ValidateUser
